var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Lead, SemiTitle, H3, Caption } from '.';
import { brandColors } from '../common/colors';
var DataBlockContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var TitleContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n"])));
var DBSubtitle = styled(SemiTitle)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tcolor: ", ";\n"], ["\n\tcolor: ", ";\n"])), brandColors.deep[100]);
var Body = styled(Lead)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmargin: 24px 0;\n"], ["\n\tmargin: 24px 0;\n"])));
var DBCaption = styled(Caption)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tcolor: ", ";\n\tpadding: 0 20px;\n"], ["\n\tcolor: ", ";\n\tpadding: 0 20px;\n"])), brandColors.deep[100]);
export var DataBlock = function (_a) {
    var title = _a.title, icon = _a.icon, subtitle = _a.subtitle, children = _a.children, button = _a.button, caption = _a.caption, className = _a.className;
    return (React.createElement(DataBlockContainer, { className: className },
        React.createElement(TitleContainer, null,
            React.createElement(H3, null, title),
            icon && icon),
        subtitle && (React.createElement(DBSubtitle, { color: brandColors.deep[100] }, subtitle)),
        React.createElement(Body, null,
            " ",
            children,
            " "),
        button && button,
        React.createElement(DBCaption, null, caption)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
